import { TemplateData, TemplateParams } from '.';

const resetPassword = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'common',
  email: {
    buttonEnabled: true,
    buttonLink: '{{setPasswordUrl}}',
    buttonText: messages.authSetPasswordSetNewPassword,
    content: `
      <p>
        ${messages.passwordResetStartContent}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.passwordResetEndContent}
      </p>
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.passwordResetSubject}`
  },
  placeholders: {
    setPasswordUrl: {
      label: messages.authSetPasswordLink,
      example: `${serverConfig.adminUrl}/set-password?key=123`
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeResetPassword
});

export default resetPassword;
